/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';

import { StyledTextarea, StyledInput } from './Input.styles';

const Input = forwardRef(({ rounded, squareCheck, ...props }, ref) => {
  const { type } = props;
  if (type === 'textarea') {
    return <StyledTextarea {...props} ref={ref} />;
  }
  return <StyledInput {...props} ref={ref} $rounded={rounded} squareCheck={squareCheck} />;
});

export default Input;
